const data = {
  columns: [
    {
      label: "",
      field: "logout",
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
    },
    {
      label: "Name",
      field: "name",
      sort: "asc",
    },
    {
      label: "Skills",
      field: "skills",
    },
    {
      label: "Capacity",
      field: "capacity",
    },
    {
      label: "CSAT",
      field: "csat",
    },
    {
      label: "Max.Chat",
      field: "max_chats",
    },
    {
      label: "Status Duration",
      field: "status_duration",
    },
    {
      label: "Assigned",
      field: "msgs_gerais",
    },
    {
      label: "Closed",
      field: "msgs_fechadas",
    },
    {
      label: "Open",
      field: "msgs_atribuidas",
    },
  ],
};

export default data;
